const config = {
  ENDPOINT: "https://falcemagazine.com/api/"
};

export default config;
